// src/index.tsx
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";  // Make sure this path is correct
import "./index.css"; // Add your global styles here

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root") // This is where React will mount the app
);
